import React, {useEffect} from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import {useNavigate} from "react-router-dom";

export default function LandingStripePaymentSuccess() {

    let navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            navigate('/stage');
        }, 2000);
    }, [])


    return (
        <>
            <Header headerType="UserOnly"/>
            <div className="bg-white dark:bg-gray-900">
                <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl">
                            Your Payment Was Successful
                        </h2>
                        <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600 dark:text-gray-400">
                            VirtualTipz have been applied to your account.
                        </p>
                        {/*<div className="mt-10 flex items-center justify-center gap-x-6">*/}
                        {/*    <a*/}
                        {/*        href="#"*/}
                        {/*        className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"*/}
                        {/*    >*/}
                        {/*        Get started*/}
                        {/*    </a>*/}
                        {/*    <a href="#" className="text-sm font-semibold leading-6 text-gray-900">*/}
                        {/*        Learn more <span aria-hidden="true">→</span>*/}
                        {/*    </a>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    );
}